module.exports = __webpack_public_path__ + "static/16-3cd731e63fb2bc0f413e9876e68df77f.mp4";